import PropTypes from 'prop-types';
import _ from 'underscore';

export const i18nPropType = PropTypes.shape({
  getString: PropTypes.func.isRequired,
  parseDecimal: PropTypes.func.isRequired,
});

export const addressPropType = PropTypes.shape({
  City: PropTypes.string,
  Country: PropTypes.string,
  Line1: PropTypes.string,
  Line2: PropTypes.string,
  PostalCode: PropTypes.string,
  StateOrProvince: PropTypes.string,
  StateOrProvinceName: PropTypes.string,
});

export const restfulServicePropType = PropTypes.objectOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object]));

export const PropTypeBaseAddPIForm = PropTypes.shape({
  findStates: PropTypes.func.isRequired,
  // Pidl
  returnUrl: PropTypes.string.isRequired,
  attachSubmitEvent: PropTypes.func.isRequired,
  detachSubmitEvent: PropTypes.func.isRequired,
  isPsd2ValidationEnabled: PropTypes.bool.isRequired,
  restfulService: restfulServicePropType.isRequired,
  culture: PropTypes.string.isRequired,
  ccBaseUrl: PropTypes.string.isRequired,
  handlePiAddSuccess: PropTypes.func.isRequired,
  setLoading: PropTypes.func.isRequired,
  pidlLoggerCreate: PropTypes.func,
});
export const BaseAddPIFormDefaultProps = PropTypes.shape({
  pidlLoggerCreate: _.noop,
});

export const PropTypeExistingPis = PropTypes.arrayOf(PropTypes.shape({
  Id: PropTypes.number,
  displayName: PropTypes.string,
  Type: PropTypes.number,
  Address: PropTypes.shape({
    Country: PropTypes.string,
  }),
}));

export const PropTypeTopUpLimit = PropTypes.shape({
  piType: PropTypes.number,
  limit: PropTypes.shape({
    Max1stPaymentAmount: PropTypes.number,
    MinPaymentAmount: PropTypes.number,
  }),
});
